import { Injectable, inject } from '@angular/core';
import { PartnersControllerService } from '@nx-customer-apps/api-planning-projects';
import { Observable, catchError, map, of, switchMap, take } from 'rxjs';
import { SettingsStore } from '../state/settings/settings.store';
import { SearchDropdownItem } from '@nx-customer-apps/shared/interfaces';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@nx-customer-apps/shared/services';
import { CompanyTileComponent } from '@nx-customer-apps/shared/ui';

@Injectable({
    providedIn: 'root'
})
export class PartnersService {
    private translateService = inject(TranslateService);
    private snackbarService = inject(SnackbarService);
    private partnersControllerService = inject(PartnersControllerService);
    private settingsStore = inject(SettingsStore);

    public getPartnersAsDropdownItems(value: string): Observable<SearchDropdownItem[]> {
        const dropdownItems$ = this.settingsStore.salesOrganization$.pipe(
            take(1),
            switchMap(salesOrganisation => {
                return this.partnersControllerService.partnersControllerGetPartners({
                    salesOrganisation: salesOrganisation!,
                    searchString: value
                });
            }),
            map(response => {
                const items = response.partners || [];
                return items.map(partner => ({
                    value: partner.partnerNumber,
                    key: partner.partnerName!,
                    customTemplate: {
                        component: CompanyTileComponent,
                        inputs: {
                            partnerName: partner.partnerName,
                            postalCode: partner.postalCode,
                            street: partner.streetAddress,
                            city: partner.city,
                            partnerNumber: partner.partnerNumber,
                            salesOrganization: partner.salesOrganization,
                            salesChannel: partner.salesChannel
                        }
                    }
                }));
            }),
            catchError(() => {
                const message = this.translateService.instant('COMMON.ERRORS.SOMETHING_WRONG');
                const action = this.translateService.instant('COMMON.BUTTONS.GOT_IT');
                this.snackbarService.showInfo(message, {
                    duration: 5000,
                    action
                });
                return of([]);
            })
        );

        return value ? dropdownItems$ : of([]);
    }
}
